import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../components/Logo';
import api from '../services/api';
import { imagePreloader } from '../utils/imagePreloader';
import './Home.css';

const Home: React.FC = () => {
  // Preload thumbnails for popular artworks on home page load
  useEffect(() => {
    const preloadPopularArtworks = async (): Promise<void> => {
      try {
        // Fetch popular artworks data
        const response = await api.get<{ topPieces: Array<{ thumbnailUrl?: string; imageUrl: string }> }>('/art/demand', {
          params: { top: 12 }
        });
        
        const topPieces = response.data.topPieces || [];
        if (topPieces.length > 0) {
          // Preload thumbnails with high priority for first 6, low for rest
          await imagePreloader.preloadThumbnails(topPieces);
        }
      } catch (error) {
        // Silently fail - preloading is non-critical
        console.debug('Failed to preload artwork thumbnails:', error);
      }
    };

    // Start preloading after a short delay to not block initial render
    const timeoutId = setTimeout(() => {
      void preloadPopularArtworks();
    }, 100);

    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <div className="home">
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">
              <Logo className="phi-logo-large" />
              <span>PHI PRINTING</span>
            </h1>
            <p className="hero-subtitle">
              Transform your photos into stunning prints. Customize, crop, and create beautiful art reproductions.
            </p>
            <div className="hero-actions">
              <Link to="/create-print" className="btn btn-primary btn-large">
                Create Custom Print
              </Link>
              <Link to="/art" className="btn btn-outline btn-large">
                Browse Art Gallery
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="features">
        <div className="container">
          <h2 className="section-title">Why Choose PHI Printing?</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon"><i className="fas fa-camera"></i></div>
              <h3>Custom Photo Printing</h3>
              <p>Upload your photos and crop them to any aspect ratio. Choose from various sizes, materials, and finishes.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon"><i className="fas fa-palette"></i></div>
              <h3>Art Reproductions</h3>
              <p>Discover beautiful art reproductions from talented artists. Search by themes, styles, and feelings.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon"><i className="fas fa-shopping-cart"></i></div>
              <h3>Easy Shopping</h3>
              <p>Add multiple items to your cart, review your purchases, and track your order history.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon"><i className="fas fa-credit-card"></i></div>
              <h3>Secure Payments</h3>
              <p>Safe and secure checkout with Square and PayPal. Your payment information is always protected.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;

